import React, { useEffect } from 'react';
import { initZendesk, configureZendesk } from './zendesk';
import { useAppSelector } from '../../store/Hooks';
import { useTranslation } from 'react-i18next';

const Chat: React.FC = () => {
    const language = useAppSelector(state => state.site.language);
    const { t, i18n } = useTranslation();

    useEffect(() => {
        const setupZendesk = () => {
            if (language && i18n.isInitialized) {
                initZendesk();
                configureZendesk(
                    language.split('-')[0],
                    t("chat.title"),
                    t("chat.online"),
                    t("chat.offline")
                );
            }
        };

        setupZendesk();
    }, [language, i18n.isInitialized, t]);

    return null;
};

export default Chat;